<template>
	<button :name="name" :class="{ success: success }" @mousedown.prevent>
		<slot v-if="!success"></slot>
		<svgicon v-if="success" name="check-arrow"></svgicon>
	</button>
</template>
<script>
import '../icons/check-arrow';
export default {
	props: {
		name: {
			type: String,
			required: true
		},
		success: {
			type: Boolean,
			default: false
		}
	}
};
</script>
<style lang="scss" scoped>
button {
	font-family: 'RobotoRegular';
	border: 0;
	padding: 0;
	color: $font-light;
	font-weight: 500;
	letter-spacing: 1px;
	text-align: center;
	background-color: $primary-state;
	border-radius: 30px;
	flex-shrink: 0;
	font-size: 15px;
	display: inline-block;
	justify-content: center;
	align-items: center;

	@media (min-width: $breakpoint-mid) {
		font-size: 16px;
	}

	* {
		vertical-align: center;
	}

	svg {
		height: 12px;
		width: 12px;
		vertical-align: middle;
		margin-left: auto;
		margin-right: auto;
	}

	&.small {
		min-width: 100px;
		height: 44px;
		padding-left: 24px;
		padding-right: 24px;
	}

	&.large {
		min-width: 150px;
		height: 54px;
		padding-left: 32px;
		padding-right: 32px;

		@media (min-width: $breakpoint-mid) {
			height: 60px;
		}
	}

	&.right {
		padding-right: 16px;

		svg {
			margin-left: 16px;
		}
	}

	&.left {
		padding-left: 16px;

		svg {
			margin-right: 16px;
		}
	}

	&.transparent {
		background-color: transparent;
		color: $primary-state;
		@media (any-hover: hover) {
			&:hover {
				color: $hover-state;
				background-color: transparent;
			}
		}

		&:active {
			outline: 0;
			background-color: transparent;
			color: $tapped-state;
		}

		&[aria-disabled='true'],
		&:disabled {
			cursor: not-allowed;
			color: $disabled-state;
			background-color: transparent;
			opacity: 1;
		}
	}

	@media (any-hover: hover) {
		&:hover {
			cursor: pointer;
			background-color: $hover-state;
		}
	}

	&:active {
		outline: 0;
		background-color: $tapped-state;
	}

	&[aria-disabled='true'],
	&:disabled {
		cursor: not-allowed;
		background-color: $disabled-state;
		opacity: 0.5;
		color: $font-dark;
	}

	&.outlined {
		background-color: $outlined-state;
		border: 2px solid $primary-state;
		color: $primary-state;

		&.lighter {
			border-color: $disabled-state;
		}

		&:not(.success) {
			&.tapped {
				border-color: $tapped-state;
				color: $tapped-state;
			}

			&:active {
				outline: 0;
				border-color: $tapped-state;
				color: $tapped-state;
			}

			&[aria-disabled='true'],
			&:disabled {
				border-color: $disabled-state;
				color: $disabled-state;
			}
			&:not(:disabled) {
				@media (any-hover: hover) {
					&:hover {
						border-color: $hover-state;
						color: $hover-state;
					}
				}
			}
		}
	}

	&.success {
		color: $font-light;
		background-color: $btn-career-selected;
		border-color: $btn-career-selected;

		@media (any-hover: hover) {
			&:hover {
				background-color: $btn-career-selected-hover;
				border-color: $btn-career-selected-hover;
			}
		}
		.text-btn-select {
			display: none;
		}

		.icon {
			display: inline;
		}
	}

	&.danger:not(:disabled) {
		color: $deleteStudentField;

		&:hover {
			color: rgba($deleteStudentField, 0.75);
		}
	}

	&.squared {
		border-radius: 4px;
	}
}
</style>
